import React from 'react';

export const Undo = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="undo">
      <mask
        id="mask0_1960_30044"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="21"
      >
        <rect
          id="Bounding box"
          y="0.283203"
          width="20"
          height="20"
          fill="#EFEEF8"
        />
      </mask>
      <g mask="url(#mask0_1960_30044)">
        <path
          id="Union"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.33334 4C6.80431 5.09037 5.92371 5.97097 4.83334 6.5C5.92371 7.02903 6.80431 7.90963 7.33334 9C7.86238 7.90963 8.74297 7.02903 9.83334 6.5C8.74297 5.97097 7.86237 5.09037 7.33334 4ZM16.3333 11.1667C14.516 10.2849 13.0484 8.81728 12.1667 7C11.2849 8.81728 9.81728 10.2849 8 11.1667C9.81728 12.0484 11.2849 13.516 12.1667 15.3333C13.0484 13.5161 14.5161 12.0484 16.3333 11.1667ZM4 14.4171C4.90864 13.9762 5.64247 13.2424 6.08333 12.3337C6.52419 13.2424 7.25802 13.9762 8.16667 14.4171C7.25802 14.8579 6.52419 15.5918 6.08333 16.5004C5.64247 15.5918 4.90864 14.8579 4 14.4171Z"
          fill="white"
        />
      </g>
    </g>
  </svg>
);
